import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const setProviderWalletAction = ({ providerId, benefitType, actions }) =>
  call(websocketFetch, 'set_provider_wallet_action', {
    provider_id: providerId,
    benefit_type: benefitType,
    actions,
  });
